// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeUploadStep-CSVDragAndDrop_cls1__UL506","cls2":"PayeeUploadStep-CSVDragAndDrop_cls2__TUt3p PayeeUploadStep-CSVDragAndDrop_cls1__UL506"};